export default __webpack_public_path__ + "static/media/work1.54a2fdf0.png";